import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { adaptBackendFilters } from '../../utils/filters';
import { DebtCard, SnapshotWardRequest } from '../../api-models';
import { DebtCardInterface, DebtMetric } from '../../types/debt.type';

export default class PostDebtCards extends BaseAdapter<DebtCard[]> implements AdapterInterface {
  rawResponse: DebtCard[];

  modifiedRequest: SnapshotWardRequest;

  async adaptResponse(request: { snapshot: string, liftDataId: string | number, wardName: string }): Promise<DebtCardInterface[]> {
    await this.fetchApiResponse('/api/debt/debt-cards', HTTPMethod.Post, this.adaptRequest(request));
    return this.rawResponse.map((debtCard) => ({
      displayName: debtCard.display_name,
      redirectUrl: debtCard.redirect_url,
      description: debtCard.description,
      metrics: debtCard.cards.map((metric): DebtMetric => ({
        value: metric.value,
        description: metric.description,
        displayName: metric.display_name,
        filters: adaptBackendFilters(metric.filters),
      })),
      graphData: debtCard.graph_data,
    }));
  }

  adaptRequest(request: { snapshot: string, liftDataId: string | number, wardName: string }): SnapshotWardRequest {
    const liftDataId = request.liftDataId === All.value ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      snapshot: request.snapshot,
      lift_data_id: liftDataId,
      ward_name: request.wardName,
    };

    return this.modifiedRequest;
  }
}
